import React, { useState } from "react";
import FilterHeader from "../../Components/FilterHeader/FilterHeader";

const TestingPage = () => {
  const [searchType, setSearchType] = useState("full_name");
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  console.log("searchType",searchType);
  console.log("searchTerm",searchTerm);
  console.log("dateRange",dateRange);


  
  return (
    <>
      <FilterHeader
        total={120}
        searchType={searchType}
        setSearchType={setSearchType}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        dateRange={dateRange}
        setDateRange={setDateRange}
        downloadExcel={() => alert("Downloading Excel...")}
        downloadPDF={() => alert("Downloading PDF...")}
        searchOptions={[
          { value: "full_name", label: "Student Name" },
          { value: "email", label: "Email" },
        ]}
        showDatePicker={false}
        showExcel={true}
        showPDF={true} // 🔽 can hide PDF easily
      />
    </>
  );
};

export default TestingPage;
